// Paletas de tema precargadas. Se aplican con: datos = { ...datosDeLaBoda, tema: temasPreset.terracota }
// Cada paleta define las variables CSS --wi-* vía tema.colores y las fuentes vía tema.fuentes.

const FUENTES_BASE = {
  display: '"Cormorant Garamond", Georgia, serif',
  cuerpo: '"Montserrat", system-ui, sans-serif',
};

export const temasPreset = {
  // Propuesta original: blanco, carbón y verde botánico.
  botanica: {
    colores: {
      fondo: "#FAF9F6",
      fondoAlt: "#F3F1EC",
      texto: "#1A1918",
      textoSuave: "#52504C",
      textoTenue: "#85827A",
      primario: "#2A4034",
      primarioSuave: "#E8ECE8",
      acento: "#C5A059",
      borde: "rgba(42, 64, 52, 0.14)",
    },
    fuentes: FUENTES_BASE,
  },

  // Terracota cálido: arcilla, crema y dorado suave.
  terracota: {
    colores: {
      fondo: "#FAF5EF",
      fondoAlt: "#F4EAE0",
      texto: "#2B1D15",
      textoSuave: "#5E4A3C",
      textoTenue: "#99826F",
      primario: "#9C4A2F",
      primarioSuave: "#F1DFD3",
      acento: "#B98A45",
      borde: "rgba(156, 74, 47, 0.16)",
    },
    fuentes: FUENTES_BASE,
  },

  // Azul noche: marino profundo, niebla azulada y dorado.
  azulNoche: {
    colores: {
      fondo: "#F5F7FA",
      fondoAlt: "#EBEFF4",
      texto: "#131A26",
      textoSuave: "#47536A",
      textoTenue: "#7F8A9E",
      primario: "#1E3252",
      primarioSuave: "#E0E7F0",
      acento: "#B08D4F",
      borde: "rgba(30, 50, 82, 0.14)",
    },
    fuentes: FUENTES_BASE,
  },
};
